import { createContext } from "react"
import type { TUser } from "@/types"

export const UserContext = createContext<TUser | null>(null)
